<template>
  <div class="hb-choose-school-list">

      <el-form class="form-wrapper">
        <el-form-item>
          <span>学校：</span>
          <el-select
            v-model="local_filter_school"
            multiple
            collapse-tags
            placeholder="请选择(支持多选)"
          >
            <el-option
              v-for="item in school_list"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="this.bindInfo.apply_academic_degree.includes('博士学位') ||
        this.bindInfo.apply_academic_degree.includes('申请博士') ||
        this.bindInfo.apply_academic_degree.includes('申请研究型硕士') ||
        this.bindInfo.apply_academic_degree.includes('研究型硕士学位') ">
          <span>类型：</span>
          <el-select
            v-model="local_filter_type"
            multiple
            collapse-tags
            placeholder="请选择(支持多选)"
          >
            <el-option
              v-for="item in kTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <span>方向：</span>
          <el-select
            v-model="local_filter_project_direction"
            multiple
            collapse-tags
            placeholder="请选择(支持多选)"
          >
            <el-option
              v-for="item in ProjectDirectionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div>
            <span>项目：</span>
            <el-input
              style="width: 200px"
              v-model="local_filter_project"
              placeholder="请输入项目关键词"
            ></el-input>
          </div>
        </el-form-item>
        <div style="display: flex; flex-direction: column; align-items: center">
          <el-button @click="filterAction" size="small" type="primary"
          >筛选</el-button
          >
        </div>
      </el-form>

      <el-table
        v-loading="loading"
        :data="lists"
        style="width: 100%"
        :default-sort="{ prop: 'school_name', order: 'descending' }"
      >
<!--        <el-table-column prop="d1" label="序号" width="50" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            {{ (requestData.page - 1) * requestData.paginate + (scope.$index + 1) }}-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="sort_id" sortable label="编号" align="center" />

        <el-table-column prop="language" label="类型" align="center" v-if="this.bindInfo.apply_academic_degree.includes('博士学位') ||
        this.bindInfo.apply_academic_degree.includes('申请博士') ||
        this.bindInfo.apply_academic_degree.includes('申请研究型硕士') ||
        this.bindInfo.apply_academic_degree.includes('研究型硕士学位') ">
          <template slot-scope="scope">
            <span v-if="scope.row.type==1">非博士选校</span>
            <span v-if="scope.row.type==2">博士选校</span>
          </template>
        </el-table-column>
        <el-table-column prop="project_name" label="项目" align="center">
          <template slot-scope="scope">
            <el-link
              style="word-break: break-word"
              type="primary"
              @click="showDetailDialog(scope.row)"
            >{{ scope.row.project_name }}</el-link
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="school_name"
          label="学校"
          align="center"
          sortable
          style="word-break: break-word"
        />
        <el-table-column prop="project_direction" label="方向" align="center">
          <template slot-scope="scope">
          <span v-if="scope.row.project_direction">
            {{ scope.row.project_direction }}
          </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="country_name" label="国家(地区)" align="center" />
        <el-table-column prop="educational_system" label="学制" align="center" />
        <el-table-column prop="language" label="语言" align="center">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.language">
              <div class="max-two-line">
                {{ scope.row.language }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column prop="" label="培养目标" align="center">
          <template slot-scope="scope">
            <el-link v-if="scope.row.train_objective" type="primary" @click="detailInfoDialog=scope.row.train_objective"
            >查看</el-link
            >
            <p v-else>--</p>
          </template>
        </el-table-column>
        <el-table-column prop="" label="课程设置" align="center">
          <template slot-scope="scope">
            <el-link v-if="scope.row.curriculum" type="primary" @click="detailInfoDialog=scope.row.curriculum">查看</el-link>
            <p v-else>--</p>
          </template>
        </el-table-column>
        <el-table-column prop="project_url" label="项目链接" align="center">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.project_url">
              <el-link
                type="primary"
                :href="
                scope.row.project_url.includes('http')
                  ? scope.row.project_url
                  : 'https://' + scope.row.project_url
              "
                target="_blank"
              >点击查看</el-link
              >
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="opening_application_time" label="开放申请时间" align="center">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.opening_application_time" :content="scope.row.opening_application_time">
              <div class="max-two-line">{{ scope.row.opening_application_time }}</div>
            </el-tooltip>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column prop="remarks" label="备注" align="center">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.remark" :content="scope.row.remark">
              <!-- <el-link type="primary" @click="showDetailDialog(scope.row)"
                >点击查看</el-link
              > -->
              <div class="max-two-line">{{ scope.row.remark }}</div>
            </el-tooltip>

            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.status == 0">待确认</p>
            <!-- <p v-else-if="scope.row.status == 1" style="color: #E6A23C">已确认(待申请)</p> -->
            <el-link
              v-else-if="scope.row.status == 2"
              type="danger"
              @click="reasonRejectionUserSchoolChoice(scope.row.content)"
            >已驳回,待老师修改</el-link
            >
            <!-- <p v-else-if="scope.row.status == 3" style="color: #409EFF">已申请</p> -->
            <p v-else-if="scope.row.status == 4" style="color: red">学生已放弃</p>
            <p v-else-if="scope.row.status == 5" style="color: #409EFF">uncon-offer</p>
            <p v-else-if="scope.row.status == 6" style="color: #409EFF">con-offer</p>
            <p v-else-if="scope.row.status == 7" style="color: red">被拒</p>
            <p v-else>--</p>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="updated_at" label="更新时间" align="center" /> -->
        <!-- <el-table-column prop="remark" label="备注" align="center" /> -->
        <el-table-column label="操作" prop="" align="center" >
          <template slot-scope="scope">
            <div class="btns-wrapper">
              <el-popconfirm
                v-if="scope.row.status == 0"
                title="是否确认该选校"
                class="btn"
                @confirm="updateStatus(scope.row.id, 1)"
              >
                <el-button slot="reference" size="mini" type="primary">确认选校</el-button>
              </el-popconfirm>
              <el-button
                class="btn"
                v-if="scope.row.status == 0"
                type="danger"
                size="mini"
                @click="refuseUserSchoolChoice(scope.row.id)"
              >驳回</el-button
              >
              <!-- <el-button
                v-if="scope.row.status == 3"
                size="mini"
                type="primary"
                style="margin-right: 5px"
                @click="showApplyResultDialog(scope.row)"
                >添加申请结果</el-button
              >
              <el-button
                v-if="
                  scope.row.status == 7 || scope.row.status == 5 || scope.row.status == 6
                "
                size="mini"
                style="margin-right: 5px"
                @click="showApplyResultDialog(scope.row)"
                >查看申请结果</el-button
              > -->
              <el-popconfirm
                title="是否放弃当前选校？"
                class="btn"
                v-if="scope.row.status == 1"
                @confirm="requestGiveUp(scope.row.id)"
              >
                <el-button
                  slot="reference"
                  size="mini"
                  type="danger"
                  style="margin-right: 5px"
                >放弃</el-button
                >
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>

    <!-- <el-pagination
        style="margin: 20px;"
        align="center"
        :current-page.sync="page.currentPage"
        :page-sizes="[15, 20, 10]"
        :page-size="15"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      /> -->
    <reject ref="reject" @reject="getList"></reject>
    <reason_rejection ref="reason_rejection"></reason_rejection>
    <HBInfoListDialog
      :visible.sync="getShowInfoListDialog"
      :dataSource="infoListDialogDataSource"
      dialogTitle="详情"
      @updateVisible="updateDetailVisiable"
    />
    <HBApplyResultDialog
      :editable="isApplyResultEditable"
      :defaultData="applyResultDialog"
      :visible="applyResultDialog != undefined || applyResultDialog != null"
      @updateVisible="applyResultDialog = undefined"
      @successCallback="getList(true)"
    />

    <el-dialog
       center
      title="查看"
      :visible="detailInfoDialog"
      width="50%"
      :before-close="()=>detailInfoDialog=null"
    >
      <p style="white-space: pre-wrap;font-size:16px" v-html="detailInfoDialog"></p>
    </el-dialog>
  </div>
</template>
<script>
import {
  add_user_school_choice,
  del_user_school_choice,
  school_list,
  update_user_school_choice,
  giveupSchoolChoiceApi,
} from "@/api/mycenter_studyabroad.js";
import HBInfoListDialog from "../HBCommon/HBInfoListDialog/HBInfoListDialog.vue";
import reject from "./reject.vue";
import reason_rejection from "./reason_rejection.vue";
import HBApplyResultDialog from "./HBApplyResultDialog/HBApplyResultDialog.vue";
export default {
  name: "TabSecond",
  props: ["flag"],
  components: {
    HBInfoListDialog,
    reject,
    reason_rejection,
    HBApplyResultDialog,
  },
  data() {
    return {
      local_filter_school: null,
      local_filter_project_direction: null,
      local_filter_type: [],
      local_filter_project: null,
      school_list: [],
      ProjectDirectionOptions: [],
      detailInfoDialog: null,
      giveupLoading: false,
      applyResultDialog: undefined,
      infoListDialogDataSource: [],
      lists: [], // 数据列表
      page: {
        total: 100000, // 总条数
        currentPage: 1,
      },
      reason: "",
      // country_list: ['中国香港', '英国', '美国', '加拿大', '澳大利亚', '新加坡', '马来西亚'],
      // project_direction_list: ['计算机', '医学', '法学'],
      addUserSchoolChoiceData: {
        id: "",
        project_name: "",
        project_direction: "",
        school_name: "",
        country_name: "",
        language: "",
        deadline: "",
        project_url: "",
        remark: "",
        user_id: "",
      },
      rules: {
        project_name: [{ required: true, message: "项目不能为空", trigger: "blur" }],
        project_direction: [
          { required: true, message: "项目方向不能为空", trigger: "change" },
        ],
        school_name: [{ required: true, message: "学校不能为空", trigger: "blur" }],
        country_name: [
          { required: true, message: "国家(地区)不能为空", trigger: "change" },
        ],
        language: [{ required: true, message: "语言要求不能为空", trigger: "blur" }],
        deadline: [{ required: true, message: "网申开始时间不能为空", trigger: "blur" }],
        project_url: [
          { required: true, message: "项目详情链接不能为空", trigger: "blur" },
        ],
        educational_system: [
          { required: true, message: "学制不能为空", trigger: "blur" },
        ],
      },
      requestData: {
        // 录播课资源请求体
        keywords: "", // 关键词
        page: 1, // 当前页
        paginate: 100000, // 分页大小
        templates_id: "",
        status: "",
        loading: "",
        user_id: "",
      },
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() < Date.now() - 8.64e7;
        },
      },
    };
  },
  created() {
    this.getUserBindInfo()
    this.$bus.on("abroad_tabs_changes", (newVal) => {
      if (newVal == this.flag) {
        this.getList(true);
      }
    });
    this.getList(true);
  },
  methods: {
    getUserBindInfo() {
      this.$store
        .dispatch(
          "userAbroad/geUserAbroadData",
          parseInt(this.$route.query.userId)
        )
        .then(() => {
          this.bindInfo = this.$store.state.userAbroad.userAbroadData;
          this.lessonOpenInfo = this.$store.state.userAbroad.lessonOpenInfo;
        })
    },
    filterAction() {
      if (!this.local_filter_project &&
        (!this.local_filter_school || this.local_filter_school.length == 0) &&
        (!this.local_filter_type || this.local_filter_type.length == 0) &&
        (!this.local_filter_project_direction || this.local_filter_project_direction.length == 0)) {
        this.lists = this.dataSource
      }
      const resultList = []
      const schoolList = this.local_filter_school;
      const projectDirectionList = this.local_filter_project_direction;
      const project = this.local_filter_project;
      const typeList = this.local_filter_type || [];

      console.log(schoolList)
      console.log(projectDirectionList)
      this.dataSource.forEach((item) => {
        var flag = true
        if (schoolList.length > 0 && !schoolList.includes(item.school_name)) {
          flag = false
        }
        if (projectDirectionList.length > 0 && !projectDirectionList.includes(item.project_direction)) {
          flag = false
        }
        if (typeList.length > 0 && !typeList.includes(item.type)) {
          flag = false
        }
        if (project && !item.project_name.toLocaleLowerCase().includes(project.toLocaleLowerCase())) {
          flag = false
        }
        if (flag == true) {
          resultList.push(item)
        }
      })
      this.lists = resultList
    },
    requestGiveUp(id) {
      this.giveupLoading = true;
      giveupSchoolChoiceApi(id)
        .then((resp) => {
          this.giveupLoading = false;
          this.$message({
            message: "已放弃",
            type: "success",
          });
          this.getList(true);
        })
        .catch((error) => {
          this.giveupLoading = false;
          this.$message.error(error.message);
        });
    },
    showApplyResultDialog(data) {
      this.applyResultDialog = data;
    },
    getList(isRefresh) {
      // 获取列表
      if (isRefresh) {
        this.requestData.page = 1;
      }
      this.requestData.user_id = this.$route.query.userId;
      this.loading = true;
      school_list(this.requestData).then((response) => {
        this.loading = false;

        const dataList = response.data.data || [];
        this.dataSource = dataList
        this.lists = dataList
        this.page.total = response.data.total
        this.page.currentPage = response.data.current_page

        this.searchList()



        // this.filterAction()
      });
    },
    searchList(){
      console.log('组件',this.dataSource)
      const l = [];
      this.dataSource.forEach((item) => {
        const index = l.findIndex(
          (subItme) => subItme.label == item.school_name
        )
        if (index < 0) {
          if (item && item.school_name) {
            l.push({
              label: item.school_name,
              value: item.school_name
            })
          }
        }
      })
      this.school_list = l
      const p = [];
      this.dataSource.forEach((item) => {
        const index = p.findIndex(
          (subItme) => subItme.label == item.project_direction
        )
        if (index < 0) {
          if (item && item.project_direction) {
            p.push({
              label: item.project_direction,
              value: item.project_direction
            })
          }
        }
      })
      this.ProjectDirectionOptions = p
    },
    refuseUserSchoolChoice(id) {
      this.$refs.reject.sendItem(id, "school_choice", 2);
    },
    reasonRejectionUserSchoolChoice(content) {
      content = JSON.parse(content);
      this.$refs.reason_rejection.sendItem(content.content, content.url);
    },
    updateStatus(id, status) {
      var reason = this.reason;
      update_user_school_choice({ id: id, con: reason, status: status }).then(
        (response) => {
          this.dialogAddUserSchoolChoice = false;
          this.getList(true);
        }
      );
    },
    editUserSchoolChoice(content) {
      this.addUserSchoolChoiceData = content;
      this.dialogAddUserSchoolChoice = true;
    },
    delUserSchoolChoice(id) {
      del_user_school_choice({ id: id })
        .then((response) => {
          this.getList(true);
        })
        .catch((error) => {});
    },
    handleSizeChange(val) {
      this.requestData.paginate = val;
      this.getList(false);
    },
    handleCurrentChange(val) {
      this.requestData.page = val;
      this.getList(false);
    },
    showDetailDialog(item) {
      this.infoListDialogDataSource = [
        { label: "项目", content: item.project_name },
        { label: "学校", content: item.school_name },
        { label: "学制", content: item.educational_system },
        { label: "方向", content: item.project_direction },
        { label: "国家(地区)", content: item.country_name },
        { label: "语言", content: item.language },
        { label: "网申开始时间", content: item.deadline },
        { label: "项目链接", content: item.project_url },
        { label: "相关课程", content: item.curriculum },
        { label: "培养目标", content: item.train_objective },
        // { label: "申请要求", content: item.limitation },
        // { label: "专业解析", content: item.view_point },
        // { label: "备注", content: item.remark },
        // { label: "更新时间", content: item.updated_at },
      ];
    },
    updateDetailVisiable(val) {
      if (val == false) {
        this.infoListDialogDataSource = [];
      }
    },
  },
  computed: {
    kTypeOptions() {
      return [
        {
          label: '非博士选校',
          value: 1
        },
        {
          label: '博士选校',
          value: 2
        }
      ]
    },
    // kSchoolOptions() {
    //   if (this.dataSource && this.dataSource.length > 0) {
    //     const l = [];
    //     this.dataSource.forEach((item) => {
    //       const index = l.findIndex(
    //         (subItme) => subItme.label == item.school_name
    //       )
    //       if (index < 0) {
    //         if (item && item.school_name) {
    //           l.push({
    //             label: item.school_name,
    //             value: item.school_name
    //           })
    //         }
    //       }
    //     })
    //     return l
    //   } else {
    //     return []
    //   }
    // },
    // // kProjectDirectionOptions() {
    // //   const apply_direction_list = this.$store.state.userAbroad.userAbroadBindData.apply_direction.split(",")
    // //   if (apply_direction_list && apply_direction_list.length > 0) {
    // //     const l = []
    // //     apply_direction_list.forEach((item) => {
    // //       if(item){
    // //         const index = l.findIndex(
    // //           (subItme) => subItme.label == item
    // //         )
    // //         if (index < 0) {
    // //           l.push({
    // //             label: item,
    // //             value: item,
    // //           });
    // //         }
    // //       }
    // //     });
    // //     return l;
    // //   } else {
    // //     return [];
    // //   }
    // // },

    isApplyResultEditable: {
      get() {
        if (
          this.applyResultDialog &&
          (this.applyResultDialog.status == 7 ||
            this.applyResultDialog.status == 5 ||
            this.applyResultDialog.status == 6)
        ) {
          return false;
        } else {
          return true;
        }
      },
    },
    getShowInfoListDialog: {
      get() {
        if (this.infoListDialogDataSource && this.infoListDialogDataSource.length > 0) {
          return true;
        } else {
          return false;
        }
      },
    },
    project_direction_list: {
      get() {
        let userAbradData = this.$store.state.userAbroad.userAbroadData;
        if (
          userAbradData &&
          userAbradData.apply_direction &&
          userAbradData.apply_direction.length > 0
        ) {
          return userAbradData.apply_direction.split(",");
        } else {
          return [];
        }
      },
    },
    country_list: {
      get() {
        let userAbradData = this.$store.state.userAbroad.userAbroadData;
        if (
          userAbradData &&
          userAbradData.apply_country &&
          userAbradData.apply_country.length > 0
        ) {
          return userAbradData.apply_country.split(",");
        } else {
          return [];
        }
      },
    },
  },
};
</script>
<style scoped lang="scss">
.form-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  .el-form-item {
    margin-bottom: 0 !important;
  }
}
.hb-choose-school-list {
  .max-two-line {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .btns-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    .btn {
      margin-bottom: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_second.vue